// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1pmky","sideMenu":"Layout_sideMenu__2exh_"};